// extracted by mini-css-extract-plugin
export default {"tableControls":"TournamentsCRUD_tableControls__Rca5G","controlBtn":"TournamentsCRUD_controlBtn__hIwvN"};